/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    let blocks: Array<CodeBlock> = [];
    const settings = feature.getSettingValue('SETTINGS');

    blocks.push({
        location: 'PRJ_CONF',
        blockType: BlockType.LOCATION,
        template: `
CONFIG_FLASH=y
CONFIG_FLASH_MAP=y
CONFIG_SETTINGS=y
CONFIG_SETTINGS_RUNTIME=y
CONFIG_NVS=y
CONFIG_SETTINGS_NVS=y`,
    });

    blocks.push({
        location: 'GLOBAL_INCLUDES',
        blockType: BlockType.LOCATION,
        template: `
#include <zephyr/settings/settings.h>`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.LOCATION,
        template: `
void stg_set(string name, string value) {
    char buf[255];
    int rc;
    /****stg_set****/
}`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.LOCATION,
        template: `
void stg_set(string name, string value);

static int app_settings_set(const char *name, size_t len,
                            settings_read_cb read_cb, void *cb_arg)
{
    const char *next;
    int rc;
    char buf[255];

    /****app_settings_set****/


    return -ENOENT;
}

struct settings_handler app_settings_conf = {
    .name = "app",
    .h_set = app_settings_set
};`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.LOCATION,
        template: `
settings_subsys_init();
settings_register(&app_settings_conf);
settings_load();
`,
    });

    for (let i = 0; i < settings.length; i += 1) {
        const setting = settings[i];
        const settingBlocks = setting.getCodeBlocks();
        blocks = blocks.concat(settingBlocks);
    }


    return blocks;
};
